import React, { useState } from 'react';

function MouserLabsHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);

  const navLinks = [
    { label: 'Home', href: 'https://mouserlabs.com/#hero' },
    { label: 'About', href: 'https://mouserlabs.com/#about' },
    { label: 'Projects', href: 'https://mouserlabs.com/#projects' },
  ];

  const contactLink = { label: 'Contact', href: 'https://mouserlabs.com/#contact' };

  return (
    <header className="fixed top-0 left-0 right-0 bg-[#121212]/90 backdrop-blur-sm border-b border-gray-800 z-[100]">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="https://mouserlabs.com" className="flex items-center">
              <img 
                src="/assets/logo-m-only.svg" 
                alt="Mouser Labs Logo" 
                className="h-10 w-auto" 
              />
              <span className="ml-3 text-xl font-orbitron font-bold text-white">
                Mouser Labs
              </span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[#B0B0B0] hover:text-white transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}

            {/* Tools Dropdown */}
            <div className="relative group">
              <button
                className="text-[#B0B0B0] hover:text-white transition-colors duration-200 flex items-center"
                onMouseEnter={() => setToolsOpen(true)}
                onMouseLeave={() => setToolsOpen(false)}
                aria-haspopup="true"
              >
                Tools
                <svg 
                  className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              
              <div 
                className={`absolute top-full left-0 mt-2 w-48 bg-gray-900 rounded-lg shadow-lg border border-gray-700 transition-all duration-200 ${
                  toolsOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                }`}
                onMouseEnter={() => setToolsOpen(true)}
                onMouseLeave={() => setToolsOpen(false)}
              >
                <a 
                  href="https://www.starlinkviewer.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block px-4 py-3 text-sm text-[#B0B0B0] hover:text-white hover:bg-[#0066CC]/20 rounded-t-lg transition-colors"
                >
                  Starlink Viewer
                </a>
                <a 
                  href="/telemetry" 
                  className="block px-4 py-3 text-sm text-[#B0B0B0] hover:text-white hover:bg-[#0066CC]/20 rounded-b-lg transition-colors"
                >
                  Telemetry Extractor
                </a>
              </div>
            </div>

            {/* Contact - after Tools to match main site header */}
            <a
              href={contactLink.href}
              className="text-[#B0B0B0] hover:text-white transition-colors duration-200"
            >
              {contactLink.label}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#B0B0B0] hover:text-white"
              aria-label="Toggle mobile menu"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-800 mt-2 pt-4">
            <div className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-[#B0B0B0] hover:text-white py-2 px-2 rounded transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              
              {/* Mobile Tools */}
              <div className="pt-1">
                <button
                  onClick={() => {
                    // Simple toggle for mobile tools
                    const toolsMenu = document.getElementById('mobile-tools-menu');
                    if (toolsMenu) toolsMenu.classList.toggle('hidden');
                  }}
                  className="w-full text-left text-[#B0B0B0] hover:text-white py-2 px-2 flex items-center justify-between"
                >
                  Tools
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
                <div id="mobile-tools-menu" className="hidden pl-4 space-y-1 mt-1">
                  <a 
                    href="https://www.starlinkviewer.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="block text-[#B0B0B0] hover:text-white py-1 text-sm"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Starlink Viewer
                  </a>
                  <a 
                    href="/telemetry" 
                    className="block text-[#B0B0B0] hover:text-white py-1 text-sm"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Telemetry Extractor
                  </a>
                </div>
              </div>

              {/* Mobile Contact - after Tools to match main site header */}
              <a
                href={contactLink.href}
                className="text-[#B0B0B0] hover:text-white py-2 px-2 rounded transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {contactLink.label}
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}

export default MouserLabsHeader;
